const styles = {
  autoCompleteContainer: {
    marginTop: '8px',
    marginBottom: '26px'
  }
};

export default styles;
